<template>

  <div class="md-layout md-alignment-center-center">
    <md-button class="md-raised" to="/carico">Carico</md-button>
    <md-button class="md-raised" to="/scarico">Scarico</md-button>
  </div>

</template>

<script>

export default {
  name: 'Dashboard'
}

</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue